import GlobalSaveService from "@/services/GlobalSaveService.js"

export const namespaced = true
export const state = {
  ListOperation: {},
  localVariableObject: {},
  localUrl: ""
}

export const mutations = {}

export const actions = {
  List({ commit, getters, dispatch }, _listOp) {
    //alert(_listOp)
    //alert("here")
    if (_listOp) {
      return GlobalSaveService.List(_listOp) //.then(response => {})
    } else {
      console.log("calling API")
    }
  }
  //   BuildListOperation() {
  //     state.ListOperation = {
  //       Url: state.localUrl,
  //       ObjectToSet: state.localVariableObject
  //     }
  //     return state.ListOperation
  //   },
  //   DestroyListOperation() {
  //     (state.listOperation = {}),
  //       (state.localVariableName = ""),
  //       (state.localUrl = "")
  //   }
}

export const getters = {}
